import type { PopperPlacementType } from "ui/popper/popper";

/**
 * `Popper` has no `anchorOrigin`, so the corner a menu scales out of is mapped here. Key on the
 * placement popper *resolved* to, never the one requested: `flip` and the `auto*` values are
 * decided at runtime, and growing from the pre-flip corner reads as inverted.
 */
const TRANSFORM_ORIGINS: Partial<Record<PopperPlacementType, string>> = {
  top: "center bottom",
  "top-start": "left bottom",
  "top-end": "right bottom",
  bottom: "center top",
  "bottom-start": "left top",
  "bottom-end": "right top",
  left: "right center",
  "left-start": "right top",
  "left-end": "right bottom",
  right: "left center",
  "right-start": "left top",
  "right-end": "left bottom",
};

export const getTransformOrigin = (placement: PopperPlacementType): string =>
  TRANSFORM_ORIGINS[placement] ?? "center top";

export const composeEventHandlers =
  <E extends { defaultPrevented?: boolean }>(
    originalHandler: ((event: E) => void) | undefined,
    ourHandler: (event: E) => void,
  ) =>
  (event: E) => {
    originalHandler?.(event);
    if (event.defaultPrevented) return;

    ourHandler(event);
  };
